import * as types from '../actions/actionTypes';

let initialState = {
    recipientDetails: {
        loading: false,
        success: true,
        data: {}
    },
    applicationHistory: {
        loading: false,
        success: true,
        data: []
    },
    applicationDetails: {
        loading: false,
        success: true,
        data: {}
    },
    updateApplicationDetails: {
        loading: false,
        success: true,
        message: '',
        data: {}
    },
    updateRecipientDetails: {
        loading: false,
        success: true
    },
    applicationNotesUpdate: {
        loading: false,
        success: true
    },
    recipientNotesUpdate: {
        loading: false,
        success: true
    },
    applicationAttachmentsUpdate: {
        loading: false,
        success: true,
        message: ''
    },
    applicationReceiptsUpdate: {
        loading: false,
        success: true,
        message: ''
    },
    export: {
        loading: false,
        success: false,
        data: ''
    }
};

export default function recipientAccountDetailsReducer(state = initialState, action) {
    switch (action.type) {
        case types.START_GET_RECIPIENT_DETAILS:
            return Object.assign({}, state, { recipientDetails: { ...action.preserveDetails ? state.recipientDetails : initialState.recipientDetails, loading: true }, });
        case types.GET_RECIPIENT_DETAILS:
            return Object.assign({}, state, { recipientDetails: { ...state.recipientDetails, ...action.response } });

        case types.START_GET_RECIPIENT_APPLICATION_HISTORY:
            return Object.assign({}, state, {
                applicationHistory: { ...initialState.applicationHistory, loading: true },
                applicationDetails: initialState.applicationDetails
            });
        case types.GET_RECIPIENT_APPLICATION_HISTORY:
            return Object.assign({}, state, { applicationHistory: { ...state.applicationHistory, ...action.response } });

        case types.START_GET_APPLICATION_DETAILS:
            return Object.assign({}, state, { applicationDetails: { ...initialState.applicationDetails, loading: true } });
        case types.GET_APPLICATION_DETAILS:
            return Object.assign({}, state, { applicationDetails: { ...state.applicationDetails, ...action.response } });

        case types.GET_RECIPIENT_APPLICATIONS_FOR_EXPORT:
                return Object.assign({}, state, { export: { ...action.response }})

        case types.UPDATE_APPLICATION_DETAILS:
            const applicationHistory = [...state.applicationHistory.data];
            const appIndex = applicationHistory.map(app => app.applicationId).indexOf(action.applicationId);
            applicationHistory[appIndex] = { ...state.applicationHistory.data[appIndex], ...action.update, lastModified: Date.now() };
            return Object.assign({}, state, { applicationHistory: { ...state.applicationHistory, data: applicationHistory } });

        case types.START_ADD_APPLICATION_NOTE:
        case types.START_UPDATE_APPLICATION_NOTE:
        case types.START_DELETE_APPLICATION_NOTE:
            return Object.assign({}, state, { applicationNotesUpdate: { ...state.applicationNotesUpdate, loading: true } });
        case types.ADD_APPLICATION_NOTE:
            return Object.assign({}, state, {
                applicationDetails: action.response.success ? {
                    ...state.applicationDetails,
                    data: {
                        ...state.applicationDetails.data,
                        notes: [...state.applicationDetails.data.notes, action.response.data]
                    }
                } : state.applicationDetails,
                applicationNotesUpdate: { success: action.response.success, loading: false }
            });
        case types.UPDATE_APPLICATION_NOTE:
            let updatedApplicationNotes = [...state.applicationDetails.data.notes];
            updatedApplicationNotes[updatedApplicationNotes.map(note => note.noteId).indexOf(action.response.data.noteId)] = action.response.data;
            return Object.assign({}, state, {
                applicationDetails: action.response.success ? {
                    ...state.applicationDetails,
                    data: {
                        ...state.applicationDetails.data,
                        notes: updatedApplicationNotes
                    }
                } : state.applicationDetails,
                applicationNotesUpdate: { success: action.response.success, loading: false }
            });
        case types.DELETE_APPLICATION_NOTE:
            return Object.assign({}, state, {
                applicationDetails: action.response.success ? {
                    ...state.applicationDetails,
                    data: { ...state.applicationDetails.data, notes: state.applicationDetails.data.notes.filter(note => note.noteId !== action.noteId) }
                } : state.applicationDetails,
                applicationNotesUpdate: { success: action.response.success, loading: false }
            });

        case types.START_ADD_RECIPIENT_NOTE:
        case types.START_UPDATE_RECIPIENT_NOTE:
        case types.START_DELETE_RECIPIENT_NOTE:
            return Object.assign({}, state, { recipientNotesUpdate: { ...state.recipientNotesUpdate, loading: true } });
        case types.ADD_RECIPIENT_NOTE:
            return Object.assign({}, state, {
                recipientDetails: action.response.success ? {
                    ...state.recipientDetails,
                    data: {
                        ...state.recipientDetails.data,
                        notes: [...state.recipientDetails.data.notes, action.response.data]
                    }
                } : state.recipientDetails,
                recipientNotesUpdate: { success: action.response.success, loading: false }
            });
        case types.UPDATE_RECIPIENT_NOTE:
            let updateRecipientNotes = [...state.recipientDetails.data.notes];
            updateRecipientNotes[updateRecipientNotes.map(note => note.noteId).indexOf(action.response.data.noteId)] = action.response.data;
            return Object.assign({}, state, {
                recipientDetails: action.response.success ? {
                    ...state.recipientDetails,
                    data: {
                        ...state.recipientDetails.data,
                        notes: updateRecipientNotes
                    }
                } : state.recipientDetails,
                recipientNotesUpdate: { success: action.response.success, loading: false }
            });
        case types.DELETE_RECIPIENT_NOTE:
            return Object.assign({}, state, {
                recipientDetails: action.response.success ? {
                    ...state.recipientDetails,
                    data: { ...state.recipientDetails.data, notes: state.recipientDetails.data.notes.filter(note => note.noteId !== action.noteId) }
                } : state.recipientDetails,
                recipientNotesUpdate: { success: action.response.success, loading: false }
            });

        case types.START_UPDATE_APPLICATION_ATTACHMENTS:
            return Object.assign({}, state, { applicationAttachmentsUpdate: { ...state.applicationAttachmentsUpdate, loading: true } });
        case types.UPDATE_APPLICATION_ATTACHMENTS:
            return Object.assign({}, state, {
                applicationDetails: (action.response.success && action.response.updatedAttachments.success) ? {
                    ...state.applicationDetails,
                    data: { ...state.applicationDetails.data, attachments: action.response.updatedAttachments.data }
                } : state.applicationDetails,
                applicationAttachmentsUpdate: { loading: false, success: action.response.success, message: action.response.message }
            });

        case types.START_UPDATE_APPLICATION_RECEIPTS:
            return Object.assign({}, state, { applicationReceiptsUpdate: { ...state.applicationReceiptsUpdate, loading: true } });
        case types.UPDATE_APPLICATION_RECEIPTS:
            return Object.assign({}, state, {
                applicationDetails: (action.response.success && action.response.updatedReceipts.success) ? {
                    ...state.applicationDetails,
                    data: { ...state.applicationDetails.data, receipts: action.response.updatedReceipts.data }
                } : state.applicationDetails,
                applicationReceiptsUpdate: { loading: false, success: action.response.success, message: action.response.message }
            });

        case types.START_UPDATE_APPLICATION:
            return { ...state, updateApplicationDetails: { ...initialState.updateApplicationDetails, loading: true } };
        case types.UPDATE_APPLICATION:
            return { ...state, updateApplicationDetails: { ...state.updateApplicationDetails, ...action.response } };

        case types.START_UPDATE_RECIPIENT_DETAILS:
            return { ...state, updateRecipientDetails: { ...initialState.updateRecipientDetails, loading: true } };
        case types.UPDATE_RECIPIENT_DETAILS:
            return { ...state, updateRecipientDetails: { ...state.updateRecipientDetails, ...action.response } };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/RecipientAccountDetailsReducer.js